var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-modal-setting',{attrs:{"title":"Default","value":_vm.valueText,"placeholder":"Not selected","is-inline":true}},[_c('core-input-checklist',{attrs:{"options":_vm.options},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }